<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative py-16 sm:py-24"
  >
    <div class="container relative">
      <h2 class="text-2xl font-bold mb-6">Profil Bilgileri</h2>

      <form @submit.prevent="updateProfile" class="max-w-lg">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2"
            >Tam Ad</label
          >
          <input
            v-model="profileData.name"
            type="text"
            class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
            required
          />
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2"
            >E-posta</label
          >
          <input
            v-model="profileData.email"
            type="email"
            class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
            required
          />
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2"
            >Telefon</label
          >
          <input
            v-model="tempPhone"
            type="text"
            class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
          />
        </div>

        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2"
            >Yeni Şifre (Opsiyonel)</label
          >
          <input
            v-model="profileData.password"
            type="password"
            class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
          />
        </div>

        <div class="flex items-center justify-between">
          <button
            type="submit"
            class="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            :disabled="loading"
          >
            {{ loading ? "Güncelleniyor..." : "Bilgileri Güncelle" }}
          </button>
        </div>
      </form>

      <div v-if="message" :class="['mt-4 p-4 rounded-lg', messageClass]">
        {{ message }}
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { updateUserProfile } from "@/services/userServices";
import {
  isValidEmail,
  isValidPassword,
  isValidPhone,
  phoneNumberFormatter,
} from "@/services/common";

const authStore = useAuthStore();
const loading = ref(false);
const message = ref("");
const messageClass = ref("");
const tempPhone = ref("");

const profileData = ref({
  name: "",
  email: "",
  password: "",
  phone: "",
});

// format phone number when user types
watch(tempPhone, (value) => {
  profileData.value.phone = phoneNumberFormatter(value);
  tempPhone.value = profileData.value.phone;
});

onMounted(async () => {
  try {
    const userData = authStore.user;
    profileData.value = {
      name: userData.FullName,
      email: userData.Email,
      password: "",
      phone: userData.PhoneNumber,
    };
    tempPhone.value = userData.PhoneNumber;
  } catch (error) {
    showMessage("Profil bilgileri yüklenirken hata oluştu", "error");
  }
});

const showMessage = (text, type = "success") => {
  message.value = text;
  messageClass.value =
    type === "success"
      ? "bg-green-100 text-green-700"
      : "bg-red-100 text-red-700";

  setTimeout(() => {
    message.value = "";
  }, 5000);
};

const updateProfile = async () => {
  if (!isValidEmail(profileData.value.email)) {
    showMessage("Geçerli bir e-posta adresi giriniz", "error");
    return;
  }

  if (profileData.value.password != "") {
    if (!isValidPassword(profileData.value.password)) {
      showMessage(
        "Şifre en az 8 karakter olmalıdır. Büyük harf, küçük harf, rakam ve özel karakter içermelidir",
        "error"
      );
      return;
    }
  }

  if (profileData.value.phone != "") {
    if (!isValidPhone(profileData.value.phone)) {
      showMessage("Geçerli bir telefon numarası giriniz", "error");
      return;
    }
  }

  loading.value = true;
  try {
    const response = await updateUserProfile(profileData.value);

    if (response.Payload) {
      authStore.updateUserName(profileData.value.name);
      authStore.updateUserEmail(profileData.value.email);
      authStore.updateUserPhone(profileData.value.phone);
      profileData.value.password = "";
    }
    showMessage("Profil bilgileriniz başarıyla güncellendi");
  } catch (error) {
    showMessage(
      error.message || "Profil güncellenirken bir hata oluştu",
      "error"
    );
  } finally {
    loading.value = false;
    profileData.value.newPassword = ""; // şifre alanını temizle
  }
};
</script>
